(ns app.front.view.group.admin.inspections.freeze-time-editor
  (:require [app.domain.booking.model :as booking-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::do-save
  (fn [{{{:availability/keys [freeze-time-days] :as data} ::unsaved
         group-id                                         ::gas/group-id} :db} _]
    (when (or (nil? freeze-time-days)
              (<= 0 freeze-time-days 100))
      {:comm/command {:command    :booking/set-freeze-time
                      :data       (-> data
                                      (assoc :authority-group-id group-id))
                      :on-success [::save-done]}})))

(rf/reg-event-fx ::save-done
  (fn [_ [_ status resp]]
    {:dispatch-n [[::entities/apply-changes status resp]
                  [::save-persisted]
                  [:notifications/add
                   :toast
                   :success
                   :success
                   :booking/freeze-time-save-success]]}))

(rf/reg-event-db ::save-persisted
  (fn [db _]
    (dissoc db ::unsaved)))

(rf/reg-event-fx ::change
  (fn [{:keys [db]} [_ attr value]]
    {:dispatch-debounce {:id      "change-freeze-time"
                         :timeout 500
                         :action  :dispatch
                         :event   [::do-save]}
     :db                (-> db
                            (assoc-in [::unsaved attr] (or value 0)))}))

(rf/reg-sub ::unsaved :-> ::unsaved)

(rf/reg-sub ::value
  :<- [::unsaved]
  :<- [::gas/group-availability]
  (fn [[unsaved availability]]
    (merge (select-keys availability [:availability/freeze-time-days
                                      :availability/freeze-time-hour
                                      :availability/freeze-time-minute])
           unsaved)))

(defn view [tr]
  (let [{:availability/keys [freeze-time-days
                             freeze-time-hour
                             freeze-time-minute]} (<sub [::value])
        current-day-value                         (or freeze-time-days 0)]
    [acommon/form {:title       (tr [:booking/freeze-time])
                   :legend-text (tr [:booking/freeze-time-help])}
     [ui/number-input {:label-text   (tr [:inspection/working-days])
                       :min          0
                       :max          booking-model/max-freeze-time-days
                       :value        current-day-value
                       :invalid      (> current-day-value 100)
                       :invalid-text (tr [:booking/freeze-time-days-invalid])
                       :on-change    #(>evt [::change
                                             :availability/freeze-time-days
                                             (-> %
                                                 futil/tval
                                                 futil/parse-int)])}]
     [ui/time-input {:id         "admin-booking-freeze-time"
                     :label-text (tr [:booking/freeze-time])
                     :class      "mt-2"
                     :on-change  (fn [[h m]]
                                   (when h
                                     (>evt [::change :availability/freeze-time-hour h]))
                                   (when m
                                     (>evt [::change :availability/freeze-time-minute m])))
                     :value      (if (and freeze-time-hour freeze-time-minute)
                                   [freeze-time-hour freeze-time-minute]
                                   booking-model/default-freeze-time)}]]))
